export const SESSION_KEY = "token";
export const OID_KEY = "oid";
